const NameFields = [
  {
    id: 'firstName',
    type: 'text',
    name: 'firstname',
    label: 'First name',
    pattern: '^[A-Za-z0-9][a-zA-Z0-9_\\\'.,/()& -]{0,49}$',
    required: true,
  },
  {
    id: 'lastName',
    type: 'text',
    name: 'lastname',
    label: 'Last name',
    pattern: '^[A-Za-z0-9][a-zA-Z0-9_\\\'.,/()& -]{0,49}$',
    required: true,
  },
];

export default NameFields;
